import { Card, Typography, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { StaffPerformance } from "../types/dashboardTypes";

interface Props {
  staff: StaffPerformance[];
}

const StaffPerformanceTable = ({ staff }: Props) => (
  <Card className="saloon-chart-card">
    <Typography variant="h6" gutterBottom>
      Staff Performance
    </Typography>
    <Table>
      <TableHead className="myCustomClass">
        <TableRow>
          <TableCell className="myCustomClass">Staff</TableCell>
          <TableCell className="myCustomClass">Orders</TableCell>
          <TableCell className="myCustomClass">Sales</TableCell>
          <TableCell className="myCustomClass">Tips</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {staff.map((s) => (
          <TableRow key={s.staffname}>
            <TableCell>{s.staffname}</TableCell>
            <TableCell>{s.totalOrders}</TableCell>
            <TableCell>₹{s.totalSales.toFixed(2)}</TableCell>
            <TableCell>₹{s.totalTips.toFixed(2)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Card>
);

export default StaffPerformanceTable;
